var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "item-list-tree" },
    [
      _c("div", { staticClass: "item-list-header header" }, [
        _c("h1", { staticClass: "item-list-title header-title" }, [
          _vm._v(_vm._s(_vm.$t(_vm.title))),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "item-list-toolbar header-toolbar btn-toolbar" },
          [_vm._t("add-button")],
          2
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "btn-toolbar item-list-actions" },
        [
          _vm._t("buttons"),
          _vm._v(" "),
          _c("div", { staticClass: "d-flex align-items-center ms-2" }, [
            _vm.loading
              ? _c(
                  "div",
                  {
                    staticClass:
                      "spinner-border spinner-border-sm text-secondary",
                    attrs: { role: "status" },
                  },
                  [
                    _c("span", { staticClass: "visually-hidden" }, [
                      _vm._v(_vm._s(_vm.$t("Loading…"))),
                    ]),
                  ]
                )
              : _vm._e(),
          ]),
          _vm._v(" "),
          _vm.multilingual && _vm.locales.length > 1
            ? _c("div", { staticClass: "btn-group btn-group-sm ms-auto" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-light dropdown-toggle",
                    attrs: {
                      type: "button",
                      id: "dropdownLangSwitcher",
                      "data-bs-toggle": "dropdown",
                      "aria-haspopup": "true",
                      "aria-expanded": "false",
                    },
                  },
                  [
                    _c("span", { attrs: { id: "active-locale" } }, [
                      _vm._v(
                        _vm._s(
                          _vm.locales.find(function (item) {
                            return item.short === _vm.currentLocale
                          }).long
                        )
                      ),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "dropdown-menu dropdown-menu-right",
                    attrs: { "aria-labelledby": "dropdownLangSwitcher" },
                  },
                  _vm._l(_vm.locales, function (locale) {
                    return _c(
                      "button",
                      {
                        key: locale.short,
                        staticClass: "dropdown-item",
                        class: { active: locale === _vm.currentLocale },
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _vm.switchLocale(locale.short)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(locale.long) +
                            "\n                "
                        ),
                      ]
                    )
                  }),
                  0
                ),
              ])
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _c("sl-vue-tree", {
        ref: "slVueTree",
        attrs: { allowMultiselect: false },
        on: { drop: _vm.drop, toggle: _vm.toggle },
        scopedSlots: _vm._u([
          {
            key: "title",
            fn: function (ref) {
              var node = ref.node
              return [
                _vm.$can("delete " + _vm.table)
                  ? _c(
                      "button",
                      {
                        staticClass: "btn btn-xs btn-link",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _vm.deleteFromNested(node)
                          },
                        },
                      },
                      [
                        _c(
                          "svg",
                          {
                            attrs: {
                              width: "12",
                              height: "12",
                              viewBox: "0 0 1792 1792",
                              fill: "currentColor",
                              xmlns: "http://www.w3.org/2000/svg",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                d: "M1490 1322q0 40-28 68l-136 136q-28 28-68 28t-68-28l-294-294-294 294q-28 28-68 28t-68-28l-136-136q-28-28-28-68t28-68l294-294-294-294q-28-28-28-68t28-68l136-136q28-28 68-28t68 28l294 294 294-294q28-28 68-28t68 28l136 136q28 28 28 68t-28 68l-294 294 294 294q28 28 28 68z",
                              },
                            }),
                          ]
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.$can("update " + _vm.table)
                  ? _c(
                      "a",
                      {
                        staticClass: "btn btn-light btn-xs ms-1 me-2",
                        attrs: {
                          href: _vm.table + "/" + node.data.id + "/edit",
                        },
                      },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.$t("Edit")) +
                            "\n            "
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.multilingual
                  ? _c("div", {
                      staticClass: "btn btn-xs btn-link btn-status me-1",
                      class:
                        node.data.status_translated === 1
                          ? "btn-status-on"
                          : "btn-status-off",
                      on: {
                        click: function ($event) {
                          return _vm.toggleStatus(node)
                        },
                      },
                    })
                  : _c("div", {
                      staticClass: "btn btn-xs btn-link btn-status me-1",
                      class:
                        node.data.status === 1
                          ? "btn-status-on"
                          : "btn-status-off",
                      on: {
                        click: function ($event) {
                          return _vm.toggleStatus(node)
                        },
                      },
                    }),
                _vm._v(" "),
                node.data.is_home === 1
                  ? _c(
                      "svg",
                      {
                        staticClass: "text-muted",
                        attrs: {
                          width: "1em",
                          height: "1em",
                          viewBox: "0 0 16 16",
                          fill: "currentColor",
                          xmlns: "http://www.w3.org/2000/svg",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            d: "M6.5 10.995V14.5a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5v-7a.5.5 0 0 1 .146-.354l6-6a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 .146.354v7a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5V11c0-.25-.25-.5-.5-.5H7c-.25 0-.5.25-.5.495z",
                          },
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            "fill-rule": "evenodd",
                            d: "M13 2.5V6l-2-2V2.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5z",
                          },
                        }),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                node.data.private === 1
                  ? _c(
                      "svg",
                      {
                        staticClass: "text-muted",
                        attrs: {
                          width: "1em",
                          height: "1em",
                          viewBox: "0 0 16 16",
                          fill: "currentColor",
                          xmlns: "http://www.w3.org/2000/svg",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            d: "M2.5 9a2 2 0 0 1 2-2h7a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-7a2 2 0 0 1-2-2V9z",
                          },
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            "fill-rule": "evenodd",
                            d: "M4.5 4a3.5 3.5 0 1 1 7 0v3h-1V4a2.5 2.5 0 0 0-5 0v3h-1V4z",
                          },
                        }),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("div", {
                  staticClass: "title",
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.multilingual
                        ? node.data.title_translated
                        : node.data.title
                    ),
                  },
                }),
                _vm._v(" "),
                node.data.redirect === 1
                  ? _c(
                      "svg",
                      {
                        staticClass: "text-muted",
                        attrs: {
                          title: _vm.$t("Redirect to first child"),
                          width: "1em",
                          height: "1em",
                          fill: "currentColor",
                          viewBox: "0 0 1792 1792",
                          xmlns: "http://www.w3.org/2000/svg",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            d: "M416 256h704q13 0 22.5 9.5t9.5 23.5v863h192q40 0 58 37t-9 69l-320 384q-18 22-49 22t-49-22l-320-384q-26-31-9-69 18-37 58-37h192v-640h-320q-14 0-25-11l-160-192q-13-14-4-34 9-19 29-19z",
                          },
                        }),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                node.data.module
                  ? _c(
                      "a",
                      {
                        staticClass:
                          "btn btn-xs btn-secondary py-0 px-1 fw-bold",
                        attrs: { href: "/admin/" + node.data.module },
                      },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(
                              _vm.$t(
                                node.data.module.charAt(0).toUpperCase() +
                                  node.data.module.slice(1)
                              )
                            ) +
                            "\n            "
                        ),
                      ]
                    )
                  : _vm._e(),
              ]
            },
          },
          {
            key: "toggle",
            fn: function (ref) {
              var node = ref.node
              return [
                node.children.length > 0 && node.isExpanded
                  ? _c(
                      "svg",
                      {
                        attrs: {
                          width: "0.8em",
                          height: "0.8em",
                          viewBox: "0 0 16 16",
                          fill: "currentColor",
                          xmlns: "http://www.w3.org/2000/svg",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            d: "M7.247 11.14L2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z",
                          },
                        }),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                node.children.length > 0 && !node.isExpanded
                  ? _c(
                      "svg",
                      {
                        attrs: {
                          width: "0.8em",
                          height: "0.8em",
                          viewBox: "0 0 16 16",
                          fill: "currentColor",
                          xmlns: "http://www.w3.org/2000/svg",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            d: "M12.14 8.753l-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z",
                          },
                        }),
                      ]
                    )
                  : _vm._e(),
              ]
            },
          },
        ]),
        model: {
          value: _vm.models,
          callback: function ($$v) {
            _vm.models = $$v
          },
          expression: "models",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }